import { useMemo } from 'react';
import { ePartyPurpose } from '../../../../../../ui-toolkit/enums/ePartyPurpose';
import { SummaryButtonProps } from './useGetSummaryButtonProps';

export const useFindButtons = (buttonItems: SummaryButtonProps[]) => {
  return useMemo(() => {
    const borrowerButton = buttonItems.find((b) => b.purpose === ePartyPurpose.borrower);
    const sellerButton = buttonItems.find((b) => b.purpose === ePartyPurpose.seller);
    const buyerButton = buttonItems.find((b) => b.purpose === ePartyPurpose.buyer);
    return { borrowerButton, sellerButton, buyerButton };
  }, [buttonItems]);
};
